/**
 * 左侧顶部Logo组件
 * zxw
 * 2024-03-38
 */
import { Image } from 'antd';

import LOGO from '../../images/logo.png';

const LogoLT = () => {
    return <>
        <Image height={35} src={LOGO}/>
    </>
}
export default LogoLT;